module.exports = __webpack_public_path__ + "img/logo.0094bf25.png";